import React from 'react'

const Max = ({ onClickHanlder, className }) => {
  return (
    <button
      onClick={() => {
        onClickHanlder && onClickHanlder()
      }}
      className={`${className} text-black px-[13px] rounded-xl py-1.5 font-medium text-sm md:text-base leading-6 hover:bg-opacity-50 transition-all duration-300 ease-in-out bg-white`}
    >
      MAX
    </button>
  )
}

export default Max
